import { Router, ResolveFn, RedirectCommand } from '@angular/router';
import {inject} from '@angular/core';
import {RenderStrategy} from '../../enums/render-strategy';
import {PointOfInterestService} from '../point-of-interest.service';
import {RouteService} from '../route.service';
import {CategoryService} from '../category.service';
import {Role} from '../../enums/role';

export const pointOfInterestResolver: ResolveFn<Promise<void | [void, void] | RedirectCommand>> = async (activatedRouteSnapshot ) => {
  const slugParam = activatedRouteSnapshot.paramMap.get('slug');
  if (!slugParam) {
    return Promise.resolve();
  }
  const router = inject(Router);
  const routeService = inject(RouteService);
  const categoryService = inject(CategoryService);
  const pointOfInterestService = inject(PointOfInterestService);
  await pointOfInterestService.resolveBySlug(slugParam, RenderStrategy.PREFER_SERVER);
  const poi = pointOfInterestService.getData().value.find(poi => poi.slug === slugParam);
  if (poi && !poi.isThemeLocation && (poi.role === Role.AMBASSADOR || poi.role === Role.FOUNDER)) {
    return Promise.all([
      routeService.resolveIndex(RenderStrategy.PREFER_SERVER),
      categoryService.resolveIndex(RenderStrategy.PREFER_SERVER)
    ]);
  }
  else {
    return new RedirectCommand(router.parseUrl('/not-found'));
  }
};
